// MBTI Population Statistics based on latest research (2024)
export const mbtiPopulationData = {
  'ISFJ': {
    totalPopulation: 13.8,
    maleRatio: 8.1,
    femaleRatio: 19.4
  },
  'ESFJ': {
    totalPopulation: 12.3,
    maleRatio: 3.6,
    femaleRatio: 8.6
  },
  'ISTJ': {
    totalPopulation: 11.6,
    maleRatio: 20.9,
    femaleRatio: 14.5
  },
  'ISFP': {
    totalPopulation: 8.8,
    maleRatio: 5.3,
    femaleRatio: 7.9
  },
  'ESTJ': {
    totalPopulation: 8.7,
    maleRatio: 10.6,
    femaleRatio: 5.6
  },
  'ESFP': {
    totalPopulation: 8.5,
    maleRatio: 4.6,
    femaleRatio: 5.7
  },
  'ENFP': {
    totalPopulation: 8.1,
    maleRatio: 5.6,
    femaleRatio: 9.2
  },
  'ISTP': {
    totalPopulation: 5.4,
    maleRatio: 13.0,
    femaleRatio: 6.1
  },
  'INFP': {
    totalPopulation: 4.4,
    maleRatio: 4.6,
    femaleRatio: 8.0
  },
  'ESTP': {
    totalPopulation: 4.3,
    maleRatio: 7.1,
    femaleRatio: 3.0
  },
  'INTP': {
    totalPopulation: 3.3,
    maleRatio: 5.4,
    femaleRatio: 3.6
  },
  'ENTP': {
    totalPopulation: 3.2,
    maleRatio: 4.3,
    femaleRatio: 1.8
  },
  'ENFJ': {
    totalPopulation: 2.5,
    maleRatio: 1.4,
    femaleRatio: 3.2
  },
  'INTJ': {
    totalPopulation: 2.1,
    maleRatio: 4.0,
    femaleRatio: 2.2
  },
  'ENTJ': {
    totalPopulation: 1.8,
    maleRatio: 2.2,
    femaleRatio: 1.4
  },
  'INFJ': {
    totalPopulation: 1.5,
    maleRatio: 1.5,
    femaleRatio: 4.2
  }
}; 
